import "../styles/index.css"

import { registerReveal } from "./reveal"

document.addEventListener("DOMContentLoaded", () => {
  registerReveal()
})
